import React from "react";

/** Appends the next page of a product list; hidden once every page is loaded. */
const LoadMoreButton = ({ hasMore, loading, onClick }) => {
  if (!hasMore) return null;
  return (
    <div className="d-flex justify-content-center mt-24">
      <button
        type="button"
        onClick={onClick}
        disabled={loading}
        className="btn btn-outline-main rounded-pill px-40 py-10 d-inline-flex align-items-center gap-8"
      >
        {loading && <i className="ph ph-spinner animate-spin" aria-hidden="true" />}
        {loading ? "Loading..." : "Load more"}
      </button>
    </div>
  );
};

export default LoadMoreButton;
